import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'Five Nines (99.999% Uptime)',
  slug: 'five-nines',
  definition: `Five nines refers to 99.999% availability, which translates to approximately 5 minutes and 15 seconds of total downtime per year. It is widely considered the gold standard for high-availability systems.

To put the different "nines" in perspective: two nines (99%) allows 3.65 days of downtime per year. Three nines (99.9%) allows 8.7 hours. Four nines (99.99%) allows 52 minutes. Five nines (99.999%) allows just 5.26 minutes. Each additional nine is exponentially harder to achieve.

Reaching five nines requires redundancy at every layer — multiple servers, multiple data centers, automatic failover, zero-downtime deployments, and monitoring that detects issues in seconds, not minutes.`,
  whyItMatters: `Five nines is the benchmark that high-profile SLAs target. Cloud providers like AWS, Google Cloud, and Azure promise four to five nines for their core services. If your SLA commits to five nines, your detection and response must be nearly instantaneous.

The cost of achieving each additional nine increases dramatically. Going from three nines to four nines might mean adding redundancy. Going from four to five nines might mean re-architecting your entire infrastructure. Understanding the tradeoffs helps you choose the right target.`,
  howUptrackHelps: `Achieving five nines requires detecting every second of downtime. A monitoring tool that checks every 5 minutes can miss entire outages that fall between checks. Uptrack's 30-second intervals ensure that even brief interruptions are captured in your uptime calculations.

Uptrack gives you accurate uptime percentages so you can track exactly where you stand relative to your availability target and see whether you are trending in the right direction.`,
  relatedTerms: [
    { name: 'Uptime', href: '/glossary/uptime' },
    { name: 'SLA', href: '/glossary/sla' },
    { name: 'Error Budget', href: '/glossary/error-budget' },
    { name: 'Downtime', href: '/glossary/downtime' },
  ],
}

export const Route = createFileRoute('/_site/glossary/five-nines')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
